import { useDraggable } from "@dnd-kit/core";
import { RotateCcw } from "lucide-react";
import { DRAG_TYPE, type RemovedImageDragData } from "@/lib/smartupload-dnd";
import { RemovedImage } from "@/store/smartupload.store";

interface RemovedImageCellProps {
  entry: RemovedImage;
  onRestore: (imageId: string) => void;
}

export function RemovedImageCell({ entry, onRestore }: RemovedImageCellProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `removed-${entry.image.id}`,
    data: {
      type: DRAG_TYPE.REMOVED_IMAGE,
      imageId: entry.image.id,
      productUrl: entry.image.product_url,
    } satisfies RemovedImageDragData,
  });

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={{ opacity: isDragging ? 0.3 : 1 }}
      className="flex flex-col gap-1 cursor-grab active:cursor-grabbing"
    >
      <div className="relative aspect-square rounded-xl overflow-hidden bg-gray-100">
        <img
          src={entry.image.product_url}
          alt={entry.image.angle}
          className="w-full h-full object-cover opacity-50"
          loading="lazy"
        />
        <button
          type="button"
          onPointerDown={(e) => e.stopPropagation()}
          onClick={() => onRestore(entry.image.id)}
          className="absolute top-1 left-1 z-10 rounded-full bg-black/50 p-0.5 text-white hover:bg-black/80 transition-colors"
        >
          <RotateCcw className="h-3 w-3" />
        </button>
      </div>
      <p className="text-[10px] text-muted-foreground truncate text-center">
        {entry.productName}
      </p>
      <p className="text-[10px] text-muted-foreground/70 truncate text-center">
        {entry.variantName}
      </p>
    </div>
  );
}
